import { gsap, Power2 } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import ScrollMagic from 'scrollmagic';
import { Draggable } from 'gsap/Draggable';
import Headroom from 'headroom.js';
import _ from 'lodash';
import jQuery from 'jquery';
import App from './App';
import Video from './Video';

// Register GSAP plugins
gsap.registerPlugin(ScrollToPlugin, Draggable);

const Menu = {
  menuOpen: false,
  $siteNav: jQuery('#site-navigation'),
  $ham: jQuery('#hamburger'),
  $bottomLine: jQuery('#bottom-line'),
  $middleLine: jQuery('#middle-line'),
  $topLine: jQuery('#top-line'),
  $tan: '#d4b68e',
  $white: '#fff',
  $black: '#161616',
  $calIcon: jQuery('.calendar-icon .cal-line'),
  $loginIcon: jQuery('#login-icon .login-1'),
  $shopIcon: jQuery('.shop-icon svg'),
  $eventIcon: jQuery('.events-li svg'),
  $cartIcon: [jQuery('#cart-icon .cart-1'), jQuery('#cart-icon .cart-2')],
  $cartIconTwo: [jQuery('#cart-icon .cart-2')],
  primaryPages: ['/legacy', '/wines', '/visit', '/belong'], // These are the primary pages without trailing slash
  disableHeadroomPages: ['event', 'wine-finder', 'contact', 'store'],
  $logo: jQuery('#Ck-logo'),
  $logoPath: jQuery('#Ck-logo .logo-st1'),
  $outerPanel: jQuery('.outer-panel'),
  $panelAnchor: jQuery('.panel-anchor'),
  $panel: jQuery('.slider-panel'),
  $panelNav: jQuery('.panel-nav'),
  $panelNavLi: jQuery('.panel-nav li'),
  $swipe: jQuery('.swipe-ui-container'),
  $menuCon: jQuery('.menu-container'),
  indx: '',

  $otherPanels: '', //jQuery('.section-slider-track').find('.slider-panel:not(".active")')
  $slideTrack: jQuery('.section-slider-track'),
  $activePanel: '',
  activePanelIndx: 0,
  $newActiveOuterPanel: '',
  $newActivePanel: '',

  myDrag: '',
  overviewDiv: document.createElement('div'),
  dragEase: Power2.easeInOut,
  dragDuration: 1,
  bookEndEase: 'elastic.out(1, 0.75)',
  dragEnabled: '',
  parsedUrl: '',

  // Method declarations - you'll need to copy-paste the implementations later
  removeSideScroll: function () {
    window.removeEventListener(...this.wheelListener);
    Menu.myDrag.disable();
    // console.log('removeSideScroll')
  },

  addSideScroll: function () {
    if (!jQuery('.slider-panel.active.opened').length) {
      window.addEventListener(...this.wheelListener); //https://medium.com/@DavideRama/removeeventlistener-and-anonymous-functions-ab9dbabd3e7b
      console.log('addSideScroll');
      Menu.myDrag.enable();
    } else {
      //  console.log('didnt attach addSideScroll')
    }
  },

  wheelListener: [
    'wheel',
    _.debounce(
      function (event) {
        Menu.watchDelta(event);
      },
      200,
      {
        leading: true,
        trailing: false,
      }
    ),
    { passive: true },
  ],

  watchDelta: function (e) {
    if (!gsap.isTweening(Menu.$slideTrack)) {
      if (e.deltaY < 0 || e.deltaX < 0) {
        console.log('scrolling up');
        this.panelMasterController(1);
      }
      if (e.deltaY > 0 || e.deltaX > 0) {
        console.log('scrolling down');
        this.panelMasterController(-1);
      }
    }
  },

  panelMasterController: function (e) {
    console.log('Slide Direction ' + e);

    var SD = isNaN(e) ? e.deltaY : e;
    if (SD < 0) {
      //&& slideindx>0
      if (!this.Anim || !this.Anim.isActive()) {
        //Anim=slide[slideindx].anim.play();

        console.log('pulling left');

        this.panelSwitch(e);
      } // inner if
    } else if (SD > 0) {
      //&& slideindx<slide.length-1
      if (!this.Anim || !this.Anim.isActive()) {
        //slideindx++;  Anim=slide[slideindx].anim.reverse();
        console.log('pulling right');

        this.panelSwitch(e);
      } // inner if
    }
  },

  panelSwitch: function (e) {
    let xTravel;
    Menu.$activePanel = this.$slideTrack.find('.outer-panel.active');

    if (e < 0) {
      //moving left
      Menu.activePanelIndx = Menu.$activePanel.index() + 1;
      this.animatePanel(e);
      Menu.updatePanelNav(Menu.activePanelIndx);
    } else if (e > 0) {
      //moving right
      Menu.activePanelIndx = Menu.$activePanel.index() - 1;
      this.animatePanel(e);
      Menu.updatePanelNav(Menu.activePanelIndx);
    } else {
      return false;
    }
  },

  panelTimeLine: gsap.timeline({ paused: true }),

  panelTL: function (xTravel) {
    //as cycling through panels with menu open

    let activeWidth;
    let activeHeight;
    let inActiveWidth;
    let inActiveHeight;

    if (App.wWidth <= 992) {
      activeWidth = '75.5%';
      activeHeight = '63%';
      inActiveWidth = '30.5%';
      inActiveHeight = '51.3%';
    } else {
      activeWidth = '60.5%';
      activeHeight = '63%';
      inActiveWidth = '49.5%';
      inActiveHeight = '51.3%';
    }

    // console.log(`activeHeight: ${activeHeight}`)

    this.panelTimeLine
      .to([Menu.$slideTrack], Menu.dragDuration, {
        xPercent: xTravel,
        ease: Menu.dragEase,
        force3D: true,
        rotation: 0.01,
      })
      .to(
        Menu.$newActivePanel,
        0.5,
        {
          // scale:1.1,
          width: activeWidth,
          height: activeHeight,
          ease: 'power2.inOut',
        },
        '-=.9'
      )
      .to(
        jQuery('.outer-panel:not(.active) .slider-panel'),
        0.5,
        {
          //  scale:.9,
          width: inActiveWidth,
          height: inActiveHeight,
          ease: 'power2.inOut',
        },
        '-=.9'
      );

    return this.panelTimeLine;
  },

  animatePanel: function (e) {
    //get direction
    let xTravel;

    if (e < 0) {
      // console.log('pulling left')
      if (Menu.activePanelIndx === 5) {
        // Empty block intentional
      } else {
        Menu.$outerPanel.removeClass('active hover');
        Menu.$panel.removeClass('active');

        Menu.$newActiveOuterPanel = Menu.$outerPanel.eq(Menu.activePanelIndx).addClass('active');
        Menu.$newActivePanel = Menu.$newActiveOuterPanel.find('.slider-panel');

        switch (Menu.activePanelIndx) {
          case 1:
            xTravel = -60;
            break;
          case 2:
            xTravel = -120;
            break;
          case 3:
            xTravel = -180;
            break;
          case 4:
            xTravel = -240;
            break;
        }

        Menu.panelTL(xTravel);
        Video.panelActiveVideo(Menu.activePanelIndx);
        Menu.panelTimeLine.play();
        //	this.updatePanelNav(xTravel);
      }
    } else if (e > 0) {
      // console.log('pulling right')

      if (Menu.activePanelIndx === -1) {
        // Empty block intentional
      } else {
        Menu.$outerPanel.removeClass('active hover');
        Menu.$panel.removeClass('active');

        Menu.$newActiveOuterPanel = Menu.$outerPanel.eq(Menu.activePanelIndx).addClass('active');
        Menu.$newActivePanel = Menu.$newActiveOuterPanel.find('.slider-panel');

        switch (Menu.activePanelIndx) {
          case 0:
            xTravel = 0;
            break;
          case 1:
            xTravel = -60;
            break;
          case 2:
            xTravel = -120;
            break;
          case 3:
            xTravel = -180;
            break;
          case 4:
            xTravel = -240;
            break;
        }

        Menu.panelTL(xTravel);
        Video.panelActiveVideo(Menu.activePanelIndx);
        Menu.panelTimeLine.play();

        //	this.updatePanelNav(xTravel);
      }
    }
    Menu.indx = '';

    Menu.panelTitleAnim(e);
    Menu.swipeArrows(Menu.activePanelIndx);
  },

  panelTitleAnim: function (e) {
    // update sizes &
    let activeTitleFS;
    let inActiveTitleFS;
    let sectionWidth;

    if (App.wWidth <= 992) {
      activeTitleFS = '3.5em';
      inActiveTitleFS = '2.5em';
      sectionWidth = '100%';
    } else {
      activeTitleFS = '8em';
      inActiveTitleFS = '5em';
      sectionWidth = '100%';
    }

    let menuAPI = Menu.activePanelIndx;
    let duration = 0.45;
    let tlEase = 'power2.inOut';

    if (menuAPI !== -1 && menuAPI !== 5) {
      for (let i = 0; i < Menu.$outerPanel.length; i++) {
        if (i == menuAPI) {
          // console.log('its may')

          let titleCenterTL = gsap.timeline({ paused: true });

          if (e < 0) {
            //pulling left

            titleCenterTL
              .set([Menu.$outerPanel.eq(i).find('.section-link')], {
                autoAlpha: 1,
                display: 'grid',
                width: sectionWidth,
              })
              .to(Menu.$outerPanel.eq(i).find('.inner-container'), 1, {
                // delay:.2,
                xPercent: -50,
                left: '50%',
                ease: Menu.dragEase,
                // Special case for Visit page (panel index 3) to ensure consistent transform
                onComplete: function () {
                  if (i === 3) {
                    // Visit panel
                    // Force consistent transform for visit panel
                    const $innerContainer = Menu.$outerPanel.eq(i).find('.inner-container');
                    // Set a consistent transform value with minimal horizontal offset
                    gsap.set($innerContainer, {
                      transform: 'translate(-50%, -50%) translate(-0.5px, 0px)',
                    });
                  }
                },
              })
              .to(
                Menu.$outerPanel.eq(i).find('.section-title'),
                0.5,
                {
                  fontSize: activeTitleFS,
                  autoAlpha: 1,
                },
                '-=.5'
              )
              .to(
                [
                  Menu.$outerPanel.eq(i).find('.section-link p'),
                  Menu.$outerPanel.eq(i).find('.section-link .right-arrow-svg'),
                ],
                duration,
                {
                  yPercent: 0,
                  ease: tlEase,
                },
                '-=.1'
              );

            //  console.log(`titleCenterTL 1`)
          } else {
            //pulling right

            titleCenterTL
              .set([Menu.$outerPanel.eq(i).find('.section-link')], {
                autoAlpha: 1,
                display: 'grid',
                width: sectionWidth,
              })
              .to(Menu.$outerPanel.eq(i).find('.inner-container'), 1, {
                //    delay:.2,
                xPercent: -50,
                left: '50%',
                ease: Menu.dragEase,
                // Special case for Visit page (panel index 3) to ensure consistent transform
                onComplete: function () {
                  if (i === 3) {
                    // Visit panel
                    // Force consistent transform for visit panel
                    const $innerContainer = Menu.$outerPanel.eq(i).find('.inner-container');
                    // Set a consistent transform value with minimal horizontal offset
                    gsap.set($innerContainer, {
                      transform: 'translate(-50%, -50%) translate(-0.5px, 0px)',
                    });
                  }
                },
              })
              .to(
                Menu.$outerPanel.eq(i).find('.section-title'),
                0.5,
                {
                  fontSize: activeTitleFS,
                  autoAlpha: 1,
                },
                '-=.5'
              )
              .to(
                [
                  Menu.$outerPanel.eq(i).find('.section-link p'),
                  Menu.$outerPanel.eq(i).find('.section-link .right-arrow-svg'),
                ],
                duration,
                {
                  yPercent: 0,
                  ease: tlEase,
                },
                '-=.1'
              );

            //  console.log(`titleCenterTL 2`)
          }

          titleCenterTL.play().eventCallback('onComplete', function () {
            if (Menu.menuOpen) {
              //so it doesn't fire on panelInit aka initial page load
              Menu.$outerPanel
                .eq(i)
                .find('.panel-anchor')
                .css('pointer-events', '')
                .addClass('ready'); //enable barba behavior
            }

            // Extra check to ensure Visit panel (index 3) has consistent transform after all animations
            if (i === 3) {
              const $innerContainer = Menu.$outerPanel.eq(i).find('.inner-container');
              gsap.set($innerContainer, {
                transform: 'translate(-50%, -50%) translate(-0.5px, 0px)',
              });
            }
          });
        } else if (i < menuAPI) {
          // console.log(`${i} im left of active`)

          Menu.$outerPanel
            .eq(i)
            .find('.panel-anchor')
            .css('pointer-events', 'none')
            .removeClass('ready'); //if clicked don't load page

          let titleRightTL = gsap.timeline({ paused: true });

          titleRightTL
            .set([Menu.$outerPanel.eq(i).find('.section-link')], {
              autoAlpha: 0,
              width: '0px',
              display: 'none',
            })
            .to(Menu.$outerPanel.eq(i).find('.section-title'), 0.9, {
              delay: 0.2,
              fontSize: inActiveTitleFS,
              autoAlpha: 0.75,
              ease: tlEase,
            })
            .to(
              Menu.$outerPanel.eq(i).find('.inner-container'),
              0.8,
              {
                xPercent: -90,
                left: '100%',
                ease: tlEase,
              },
              '-=.6'
            )
            .to(
              [
                Menu.$outerPanel.eq(i).find('.section-link p'),
                Menu.$outerPanel.eq(i).find('.section-link .right-arrow-svg'),
              ],
              duration,
              {
                yPercent: -230,
                ease: tlEase,
              },
              '-=.1'
            );

          titleRightTL.play();
        } else if (i > menuAPI) {
          // console.log(`${i} im right of active`)

          Menu.$outerPanel
            .eq(i)
            .find('.panel-anchor')
            .css('pointer-events', 'none')
            .removeClass('ready'); //if clicked don't load page

          let titleLeftTL = gsap.timeline({ paused: true });

          titleLeftTL
            .set([Menu.$outerPanel.eq(i).find('.section-link')], {
              autoAlpha: 0,
              width: '0px',
              display: 'none',
            })
            .to(Menu.$outerPanel.eq(i).find('.section-title'), 0.9, {
              delay: 0.2,
              fontSize: inActiveTitleFS,
              autoAlpha: 0.75,
              ease: tlEase,
            })
            .to(
              Menu.$outerPanel.eq(i).find('.inner-container'),
              0.8,
              {
                xPercent: -10,
                left: 0,
                ease: tlEase,
              },
              '-=.6'
            )
            .to(
              [
                Menu.$outerPanel.eq(i).find('.section-link p'),
                Menu.$outerPanel.eq(i).find('.section-link .right-arrow-svg'),
              ],
              duration,
              {
                yPercent: -230,
                ease: tlEase,
              },
              '-=.1'
            );

          titleLeftTL.play();
        }
      }
    } else {
      // -1 or 5
      if (menuAPI == 5) {
        //console.log(`menuapi is 5`)

        gsap.fromTo(
          [Menu.$slideTrack],
          0.5,
          {
            xPercent: -240,
            ease: Menu.bookEndEase,
          },
          {
            xPercent: -245,
            ease: Menu.bookEndEase,
            onStart: function () {
              setTimeout(function () {
                gsap.fromTo(
                  [Menu.$slideTrack],
                  0.5,
                  {
                    xPercent: -245,
                    ease: Menu.bookEndEase,
                  },
                  {
                    xPercent: -240,
                    ease: Menu.bookEndEase,
                  }
                );
              }, 200);
            },
          }
        );
      } else {
        //console.log(`menuapi is -1`)

        gsap.fromTo(
          [Menu.$slideTrack],
          0.5,
          {
            xPercent: 0,
            ease: Menu.bookEndEase,
          },
          {
            xPercent: 5,
            ease: Menu.bookEndEase,
            onStart: function () {
              setTimeout(function () {
                gsap.fromTo(
                  [Menu.$slideTrack],
                  0.5,
                  {
                    xPercent: 5,
                    ease: Menu.bookEndEase,
                  },
                  {
                    xPercent: 0,
                    ease: Menu.bookEndEase,
                  }
                );
              }, 200);
            },
          }
        );
      }
    } // -1 or 5
  },

  swipeArrows: function (panel) {
    if (panel == 0 || panel == -1) {
      console.log('zero start');
      gsap.to(Menu.$swipe.find('.left-arrow'), 0.25, { autoAlpha: 0 });
    } else if (panel == 4 || panel == 5) {
      console.log('end');
      gsap.to(Menu.$swipe.find('.right-arrow'), 0.25, { autoAlpha: 0 });
    } else {
      console.log('swipe else');
      gsap.to(Menu.$swipe.find('.arrows'), 0.25, { autoAlpha: 1 });
    }

    gsap.fromTo(
      Menu.$swipe.find('.circle'),
      2,
      { xPercent: 0 },
      { xPercent: -600, yoyo: true, repeat: -1, ease: 'Power3.inOut' }
    );
  },

  setHamburger: function () {
    gsap.set(Menu.$topLine, { transformOrigin: '92% -60%' });
    gsap.set(Menu.$bottomLine, { transformOrigin: '87% 40%' });

    // gsap.set(Q('#top-line-mobile'),{transformOrigin:'92% 30%'})
    // gsap.set(Q('#bottom-line-mobile'),{transformOrigin:'102% 30%'})
  },

  menuTL: gsap.timeline({ paused: true }),

  menuTimeLine: function () {
    console.log('Menu', Menu.$cartIconTwo);

    Menu.menuTL = gsap
      .timeline({ paused: true })
      .set(App.wWidth < 980 ? Menu.$swipe : Menu.$panelNav, {
        display: App.wWidth < 980 ? 'none' : 'flex',
      })
      .fromTo(Menu.$middleLine, { autoAlpha: 1 }, { autoAlpha: 0 }, '-=0')
      .fromTo(
        Menu.$bottomLine,
        { rotation: 0 },
        {
          rotation: 45,
          ease: 'power4.inOut',
          stroke: Menu.$tan,
        },
        '-=.5'
      )
      .fromTo(
        Menu.$topLine,
        { rotation: 0 },
        {
          rotation: -45,
          ease: 'power4.inOut',
          stroke: Menu.$tan,
        },
        '-=.5'
      )
      .to(Menu.$cartIconTwo, { fill: Menu.$tan }, '-=.5')
      .fromTo(
        [Menu.$panelNav, Menu.$swipe],
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: 'power2.inOut' },
        '+=0'
      )
      .set(Menu.menuOpen, { onComplete: Menu.animateToMenuViewTimeline, onCompleteParams: [true] })
      .call(Menu.pageTeaser)
      .to([Menu.$loginIcon, Menu.$cartIcon, Menu.$calIcon], { stroke: Menu.$tan }, '-=.5')
      .to([Menu.$shopIcon, Menu.$eventIcon, Menu.$calIcon], { fill: Menu.$tan }, '-=1');

    return Menu.menuTL;
  },

  menuColorTL: gsap.timeline({ paused: true }),

  menuColor: function (forward, reverse) {
    // if(app.primaryPage){

    console.log({
      cartIcon: Menu.$cartIconTwo,
      logoPath: Menu.$logoPath,
    });

    // if(set){
    gsap.set(
      [
        Menu.$topLine,
        Menu.$middleLine,
        Menu.$bottomLine,
        Menu.$cartIcon,
        Menu.$loginIcon,
        Menu.$calIcon,
      ],
      { stroke: Menu.$white }
    );
    /// gsap.set([Menu.$cartIconTwo, Menu.$logoPath], { fill: Menu.$white });
    //  }

    Menu.menuColorTL
      .fromTo(
        Menu.$bottomLine,
        { duration: 0.5, stroke: Menu.$white },
        { ease: 'power4.inOut', stroke: Menu.$tan },
        '-=.5'
      )
      .fromTo(
        [Menu.$topLine, Menu.$middleLine],
        { duration: 0.5, stroke: Menu.$white },
        { ease: 'power4.inOut', stroke: Menu.$tan },
        '-=.5'
      )
      .fromTo(
        [Menu.$loginIcon, Menu.$cartIcon, Menu.$calIcon],
        { duration: 0.5, stroke: Menu.$white },
        { ease: 'power2.inOut', stroke: Menu.$tan },
        '-=.5'
      )
      .fromTo(
        [Menu.$cartIconTwo, Menu.$shopIcon, Menu.$eventIcon, Menu.$calIcon],
        { duration: 0.5, fill: Menu.$white },
        { ease: 'power2.inOut', fill: Menu.$tan },
        '-=.5'
      );
    // }else{

    //   //  if(set){
    //         gsap.set([Menu.$topLine, Menu.$middleLine,Menu.$bottomLine,Menu.$cartIcon,Menu.$loginIcon],{stroke:Menu.$black})
    //         gsap.set([Menu.$cartIconTwo, Menu.$logoPath],{fill:Menu.$black})
    //   //  }

    //     Menu.menuColorTL.fromTo(Menu.$bottomLine,.5,{stroke:Menu.$black },{ ease: 'power4.inOut', stroke:Menu.$tan},"-=.5")
    //     .fromTo([Menu.$topLine, Menu.$middleLine],.5,{stroke:Menu.$black },{ease: 'power4.inOut', stroke:Menu.$tan},"-=.5")
    //     .fromTo([Menu.$loginIcon,Menu.$cartIcon],.5,{stroke:Menu.$black},{ease: 'power2.inOut',stroke:Menu.$tan},"-=.5")
    //     .fromTo([Menu.$cartIconTwo],.5,{fill:Menu.$black},{ease: 'power2.inOut',fill:Menu.$tan},"-=.5")
    // }

    if (forward) {
      Menu.menuColorTL.progress(0, false);
      Menu.menuColorTL.play();
      console.log('Menu.menuColorTL is play');
    }

    if (reverse) {
      Menu.menuColorTL.progress(1, false);
      Menu.menuColorTL.reverse();
      console.log('Menu.menuColorTL is reverse');
    }
  },

  hamburgerClick: function () {
    jQuery('#hamburger,.menu-helper').on('click', function () {
      if (!App.primaryPage) {
        Menu.menuLogicSecondary();
      } else {
        Menu.menuLogic();
      }
    });
  },

  pageTeaserTL: '',

  pageTeaser: function () {
    this.pageTeaserTL = gsap.timeline({ paused: true });

    this.pageTeaserTL.fromTo(
      ['.intro-container', '#volume-bars'],
      0.45,
      { autoAlpha: 0 },
      { autoAlpha: 1 }
    );

    if (!Menu.menuOpen) {
      this.pageTeaserTL.progress(0, false);
      setTimeout(function () {
        Menu.pageTeaserTL.play();
      }, 750);
    } else {
      this.pageTeaserTL.progress(1, false);
      this.pageTeaserTL.reverse();
    }
  },

  menuLogic: function () {
    let scrollDuration;

    if (gsap.isTweening(this.$ham)) {
      return false;
    } else {
      Menu.dragInit();

      sessionStorage.removeItem('preFilter');

      if (!Menu.menuOpen) {
        Menu.menuOpen = true;

        Menu.$siteNav.addClass('menu-open');

        // Handle collections sub-nav when menu opens
        const collectionsSubNav = document.querySelector('.collections-sub-nav-wrapper');
        if (collectionsSubNav) {
          gsap.to(collectionsSubNav, {
            autoAlpha: 0,
            duration: 0.3,
            ease: 'power2.inOut',
            onComplete: () => {
              collectionsSubNav.style.pointerEvents = 'none';
            },
          });
        }

        Video.startMenuVideos();

        //when animating back to menu view make sure copy under title and arrow aren't visible
        gsap.set(
          [
            Menu.$outerPanel.eq(Menu.activePanelIndx).find('.section-link p'),
            Menu.$outerPanel.eq(Menu.activePanelIndx).find('.section-link .right-arrow-svg'),
          ],
          { y: -230 }
        );

        if (document.documentElement.scrollTop === 0) {
          scrollDuration = 0.1;
        } else {
          scrollDuration = 1.5;
        }

        gsap.to(window, {
          duration: scrollDuration,
          scrollTo: { y: 0, x: 0 },
          ease: 'power2.inOut',
          onStart: function () {
            console.log('onStart menu logic');
            Menu.addSideScroll();
            App.disableScroll();
            Menu.panelSetOpen();
            // Menu.menuTL.play()
          },
          onComplete: function () {
            let $currentPanel = Menu.$slideTrack.find('.outer-panel.active').find('.slider-panel');
            $currentPanel.find('.panel-anchor').addClass('ready'); //enable barba behavior
            Menu.menuTL.play(); //.eventCallback('onComplete',Menu.animateToMenuViewTimeline(true) )
          },
        });
      } else {
        Menu.closeMenuLogic();

        Menu.menuOpen = false;

        // Handle collections sub-nav when menu closes
        const collectionsSubNav = document.querySelector('.collections-sub-nav-wrapper');
        if (collectionsSubNav) {
          gsap.to(collectionsSubNav, {
            autoAlpha: 1,
            duration: 0.3,
            ease: 'power2.inOut',
            onStart: () => {
              collectionsSubNav.style.pointerEvents = 'auto';
            },
          });
        }

        Menu.navBehavior();

        Menu.removeSideScroll();
        App.enableScroll();
        Menu.panelSetOpen();
        Menu.menuTL.progress(1, false);

        Menu.menuTL
          .timeScale(1.5)
          .reverse()
          .eventCallback('onReverseComplete', function () {
            Menu.animateToMenuViewTimeline(false);
            Menu.$siteNav.removeClass('menu-open');
            setTimeout(function () {
              Video.pauseMenuVideos();
            }, 2000);
          });
      }
    }
  },

  menuLogicSecondary: function () {
    let promise = new Promise((resolve) => {
      App.curtainBottomToTop();
      setTimeout(() => {
        gsap.set(Menu.$menuCon, { height: '100vh' });

        Menu.navBehavior();

        Menu.menuLogic();

        gsap.to(window, { duration: 0, scrollTo: 0 });
        resolve('done');
      }, 1100);
    });

    promise.then(() => {
      App.curtainTopToBottom();
    });
  },

  closeMenuLogic: function () {
    let currentPage = App.getURLPath();

    if (Menu.primaryPages.includes(currentPage) || currentPage === '/') {
      App.primaryPage = true;

      if (currentPage === '/') {
        Menu.jumpAnimation(0);
        Menu.$panelNav.find('li:nth-of-type(1)').addClass('is-active').trigger('focus');
        Video.homeVideo.play();
        gsap.to(window, { duration: 0, scrollTo: 0 }); // Ensure scroll position is at top
      } else if (currentPage == Menu.primaryPages[0]) {
        Menu.jumpAnimation(1);
        Menu.$panelNav.find('li:nth-of-type(2)').addClass('is-active').trigger('focus');
        Video.legacyVideo.play();
        gsap.to(window, { duration: 0, scrollTo: 0 }); // Ensure scroll position is at top
      } else if (currentPage == Menu.primaryPages[1]) {
        Menu.jumpAnimation(2);
        Menu.$panelNav.find('li:nth-of-type(3)').addClass('is-active').trigger('focus');
        Video.winesVideo.play();
        gsap.to(window, { duration: 0, scrollTo: 0 }); // Ensure scroll position is at top
      } else if (currentPage == Menu.primaryPages[2]) {
        Menu.jumpAnimation(3);
        Menu.$panelNav.find('li:nth-of-type(4)').addClass('is-active').trigger('focus');
        Video.visitVideo.play();
        gsap.to(window, { duration: 0, scrollTo: 0 }); // Ensure scroll position is at top
      } else if (currentPage == Menu.primaryPages[3]) {
        Menu.jumpAnimation(4);
        Menu.$panelNav.find('li:nth-of-type(5)').addClass('is-active').trigger('focus');
        Video.belongVideo.play();
        gsap.to(window, { duration: 0, scrollTo: 0 }); // Ensure scroll position is at top
      }
    } else {
      //secondary page

      console.log('close menu secondary page');

      let promise = new Promise((resolve) => {
        App.curtainBottomToTop();

        gsap.set(Menu.$menuCon, { height: '0vh' });

        Menu.navBehavior();

        gsap.to(window, { duration: 0, scrollTo: 0 });
        setTimeout(() => {
          resolve('done');
        }, 800);
      });

      promise.then(() => {
        App.curtainTopToBottom();
      });
    }
  },

  quickJumpAnimation: function (panelIndex) {
    let xTravel;

    Menu.activePanelIndx = panelIndex;

    Menu.$outerPanel.removeClass('active hover');
    Menu.$panel.removeClass('active');

    Menu.$newActiveOuterPanel = Menu.$outerPanel.eq(panelIndex).addClass('active');
    Menu.$newActivePanel = Menu.$newActiveOuterPanel.find('.slider-panel');

    switch (panelIndex) {
      case 0:
        xTravel = 0;

        break;
      case 1:
        xTravel = -60;

        break;
      case 2:
        xTravel = -120;

        break;
      case 3:
        xTravel = -180;

        break;
      case 4:
        xTravel = -240;

        break;
    }

    Menu.panelTitleAnim();
    Menu.updatePanelNav(panelIndex);
    Menu.panelTL(xTravel);
    Menu.panelTimeLine.progress(1);
  },

  jumpAnimation: function (panelIndex) {
    if (this.menuOpen) {
      let xTravel;

      Menu.activePanelIndx = panelIndex;

      Menu.$outerPanel.removeClass('active hover');
      Menu.$panel.removeClass('active');

      Menu.$newActiveOuterPanel = Menu.$outerPanel.eq(panelIndex).addClass('active');
      Menu.$newActivePanel = Menu.$newActiveOuterPanel.find('.slider-panel');

      switch (panelIndex) {
        case 0:
          xTravel = 0;

          break;
        case 1:
          xTravel = -60;

          break;
        case 2:
          xTravel = -120;

          break;
        case 3:
          xTravel = -180;

          break;
        case 4:
          xTravel = -240;

          break;
      }

      Menu.panelTitleAnim();
      Menu.updatePanelNav(panelIndex);
      Menu.panelTL(xTravel);
      Menu.panelTimeLine.play();

      // Fix transform for Visit page during Barba transitions
      if (panelIndex === 3) {
        setTimeout(() => {
          const $visitInnerContainer = jQuery('.outer-panel[data-page="visit"].active').find(
            '.inner-container'
          );
          gsap.set($visitInnerContainer, {
            transform: 'translate(-50%, -50%) translate(-0.5px, 0px)',
          });
        }, 300);
      }

      //console.log('clicky')
      Video.panelActiveVideo(Menu.activePanelIndx);
    } //menu open
  },

  activePanelNav: function () {
    Menu.$panelNavLi.on({
      click: function () {
        Menu.updatePanelNav(jQuery(this).index(), true);
      },
      // mouseenter: function () {
      //   gsap.to(jQuery(this).find('p'), 0.15, {
      //     autoAlpha: 1,
      //     yPercent: -100,
      //     ease: 'power2.inOut',
      //   });
      // },
      // mouseleave: function () {
      //   gsap.to(jQuery(this).find('p'), 0.15, {
      //     autoAlpha: 0,
      //     yPercent: 0,
      //     ease: 'power2.inOut',
      //   });
      // },
    });
  },

  updatePanelNav: function (index, click) {
    //click is boolean

    if (click === undefined) {
      click = false;
    }

    switch (index) {
      case -1:
        break;
      case 0:
        Menu.$panelNav.find('.is-active').removeClass('is-active');
        Menu.$panelNav.find('li:nth-of-type(1)').addClass('is-active').trigger('focus');
        break;
      case 1:
        Menu.$panelNav.find('.is-active').removeClass('is-active');
        Menu.$panelNav.find('li:nth-of-type(2)').addClass('is-active').trigger('focus');
        break;
      case 2:
        Menu.$panelNav.find('.is-active').removeClass('is-active');
        Menu.$panelNav.find('li:nth-of-type(3)').addClass('is-active').trigger('focus');
        break;
      case 3:
        Menu.$panelNav.find('.is-active').removeClass('is-active');
        Menu.$panelNav.find('li:nth-of-type(4)').addClass('is-active').trigger('focus');
        break;
      case 4:
        Menu.$panelNav.find('.is-active').removeClass('is-active');
        Menu.$panelNav.find('li:nth-of-type(5)').addClass('is-active').trigger('focus');
        break;
      case 5:
        break;
    }

    if (click === true) {
      this.jumpAnimation(index);
    }
  },

  initPanelHelper(panelNumber) {
    Menu.quickJumpAnimation(panelNumber);
    Menu.$outerPanel.eq(panelNumber).addClass('active');
    Menu.$outerPanel.eq(panelNumber).find('.slider-panel').addClass('opened');
    Menu.$outerPanel.eq(panelNumber).find('.panel-anchor').removeClass('ready');
    Menu.$panelNavLi.eq(panelNumber).addClass('is-active').trigger('focus');

    Menu.activePanelIndx = panelNumber;
  },

  animateToMenuViewTL: '',

  animateToMenuViewTimeline: function (forward) {
    let activeWidth;
    let activeHeight;

    if (App.wWidth <= 992) {
      activeWidth = '75.5%';
      activeHeight = '63%';
    } else {
      activeWidth = '60.5%';
      activeHeight = '63%';
    }

    let $currentPanel = Menu.$slideTrack.find('.outer-panel.active').find('.slider-panel');

    Menu.animateToMenuViewTL = gsap.timeline({ paused: false });

    Menu.animateToMenuViewTL
      .fromTo(
        $currentPanel,
        1,
        { width: '100%', height: '100%' },
        { width: activeWidth, height: activeHeight, ease: 'power2.inOut' },
        '-=.5'
      )
      .fromTo(
        [
          Menu.$outerPanel.eq(Menu.activePanelIndx).find('.section-link p'),
          Menu.$outerPanel.eq(Menu.activePanelIndx).find('.section-link .right-arrow-svg'),
        ],
        0.45,
        {
          y: -230,
          ease: 'power2.inOut',
        },
        {
          y: 0,
        },
        '-=.35'
      );

    if (forward) {
      Menu.animateToMenuViewTL.progress(0, false);
      Menu.animateToMenuViewTL.play();
      console.log('animateToMenuViewTL is play');

      Video.homeVideo.muted = true;
    } else {
      Menu.animateToMenuViewTL.progress(1, false);
      Menu.animateToMenuViewTL.reverse();
      console.log('animateToMenuViewTL is reverse');

      //play home video sound
      setTimeout(() => {
        if (Menu.activePanelIndx == 0) {
          Video.homeVideo.muted = true;
          Video.soundbar();
        }
      }, 1000);
    }

    //  this.animateToMenuViewTL.play()
  },

  panelSetOpen: function () {
    if (this.menuOpen) {
      Menu.$slideTrack.find('.outer-panel.active .slider-panel').removeClass('opened');
    } else {
      Menu.$slideTrack.find('.outer-panel.active .slider-panel').addClass('opened');
    }
  },

  dragInit: function () {
    //set up drag object
    Menu.myDrag = new Draggable(Menu.overviewDiv, {
      trigger: '.slider-mask',
      type: 'x',
      //minimumMovement:6,
      lockAxis: true,
      dragResistance: 0.25,
      cursor: 'ew-resize',
      //bounds: document.getElementById("division-wrMenuer"),
      throwProps: true,

      onDragStart: function () {
        let xDirection = this.getDirection('start');

        if (xDirection == 'right' || xDirection == 'right-up' || xDirection == 'right-down') {
          // Empty block intentional
        } else if (xDirection == 'left' || xDirection == 'left-up' || xDirection == 'left-down') {
          // Empty block intentional
        }
      },
      onDragEnd: function () {
        //	console.log("drag ended");

        let xDirection = this.getDirection('start');
        let direction;

        if (xDirection == 'right' || xDirection == 'right-up' || xDirection == 'right-down') {
          direction = 1;
        } else if (xDirection == 'left' || xDirection == 'left-up' || xDirection == 'left-down') {
          direction = -1;
        }

        //	console.log(direction);

        Menu.panelMasterController(direction);
      },
    });
  },

  panelOpenMenuBehavior: function (e) {
    App.dataPage = '';
    let panelIndex = jQuery(this).index();

    Menu.jumpAnimation(panelIndex);
  },

  panelClickData: function () {
    this.$outerPanel.on({
      click: function (e) {
        if (Menu.menuOpen) {
          App.dataPage =
            jQuery(this).hasClass('active') &&
            !jQuery(this).find('.slider-panel').hasClass('opened')
              ? jQuery(this).attr('data-page')
              : Menu.panelOpenMenuBehavior.call(jQuery(this), e);
        }
      },
    });
  },

  panelSetUpOtherPanels: function () {
    let inActiveWidth;
    let inActiveHeight;

    if (App.wWidth <= 992) {
      inActiveWidth = '30.5%';
      inActiveHeight = '51.3%';
    } else {
      inActiveWidth = '49.5%';
      inActiveHeight = '51.3%';
    }

    // setting up other panels so animation is smooth
    gsap.to(jQuery('.outer-panel:not(.active) .slider-panel'), 0.5, {
      //  scale:.9,
      width: inActiveWidth,
      height: inActiveHeight,
      ease: 'power2.inOut',
    });
  },

  panelAnchorLink: function () {
    Menu.$panelAnchor.on({
      click: function (e) {
        e.preventDefault();

        let _this = jQuery(this);
        let panelIndex = _this.closest('.outer-panel').index();
        let href = _this.attr('href');

        console.log(`panelIndex: ${panelIndex}`);
        console.log(`Menu.activePanelIndx: ${Menu.activePanelIndx}`);

        // Force scroll to top when navigating to any page, especially wines
        const forceSrollTop = function () {
          // Set a session flag to ensure we scroll to top on the destination page
          sessionStorage.setItem('scrollToTop', 'true');

          // For wines page specifically
          if (href.includes('/wines')) {
            sessionStorage.setItem('fromMenuToWines', 'true');
          }
        };

        // Check if we're already on the same page
        if (App.getURLPath() === href || (App.getURLPath() === '/' && href === '/')) {
          console.log('Same page - closing menu');
          if (Menu.menuOpen) {
            Menu.$ham.trigger('click');
          }
          return;
        }

        // No more Barba - using standard navigation with animation
        if (Menu.menuOpen) {
          // Set transition state for animations
          App.dataTrans = 'menuToPage';

          // First close the menu with animation
          Menu.menuOpen = false;
          Menu.removeSideScroll();
          App.enableScroll();
          Menu.panelSetOpen();

          // Run animations
          const $currentPanel = Menu.$slideTrack.find('.outer-panel.active').find('.slider-panel');
          const tl = gsap.timeline();

          tl.to($currentPanel, {
            duration: 1,
            width: '100%',
            height: '100%',
            ease: 'power2.inOut',
          });

          Menu.menuTL.progress(1, false);
          Menu.menuTL.timeScale(1.5).reverse();

          // After animations, navigate to the page
          forceSrollTop();

          setTimeout(() => {
            window.location.href = href;
          }, 800);
        } else {
          // Direct navigation with simple animation
          App.curtainBottomToTop();
          forceSrollTop();

          setTimeout(() => {
            window.location.href = href;
          }, 800);
        }
      },
    });
  },

  initPanel: function () {
    let currentPage = App.getURLPath();

    if (Menu.primaryPages.includes(currentPage) || currentPage === '/') {
      App.primaryPage = true;

      if (currentPage === '/') {
        console.log('youre on home page');
        Menu.initPanelHelper(0);
        Menu.panelTitleAnim(-1); //bookend

        //play home video sound
        // setTimeout(() => {
        //   if (Menu.activePanelIndx == 0) {
        //     Video.homeVideo.muted = false;

        //     if (Video.homeVideo.muted === true) {
        //       Video.soundTL.seek('end').pause();
        //     }
        //   }

        //   //    Video.homeVideo.onpause = function() {
        //   //         console.log("The video has been paused");

        //   //             Video.homeVideo.muted = true;
        //   //             Video.homeVideo.play()

        //   //         if( Video.homeVideo.muted === true){
        //   //             Video.soundTL.seek('end').pause();
        //   //         }
        //   //     }
        // }, 1000);
      } else if (currentPage == Menu.primaryPages[0]) {
        console.log('youre on legacy');
        Menu.initPanelHelper(1);
        Menu.panelTitleAnim(1);
      } else if (currentPage == Menu.primaryPages[1]) {
        console.log('youre on wines');
        Menu.initPanelHelper(2);
        Menu.panelTitleAnim(2);
      } else if (currentPage == Menu.primaryPages[2]) {
        console.log('youre on visit');
        Menu.initPanelHelper(3);
        Menu.panelTitleAnim(3);

        // Fix for Visit page transform inconsistency
        setTimeout(() => {
          const $visitInnerContainer = jQuery('.outer-panel[data-page="visit"].active').find(
            '.inner-container'
          );
          gsap.set($visitInnerContainer, {
            transform: 'translate(-50%, -50%) translate(-0.5px, 0px)',
          });
        }, 300);
      } else if (currentPage == Menu.primaryPages[3]) {
        console.log('youre on belong');
        Menu.initPanelHelper(4);
        Menu.panelTitleAnim(4);
      }
    } else {
      App.primaryPage = false;

      console.log('not primary page');

      Menu.initPanelHelper(0);
      Menu.panelTitleAnim(-1); //bookend

      gsap.set(this.$menuCon, { height: '0vh' }); //shrink menu container for curtain review on secondary pages

      jQuery(window).on('load', function () {
        if (App.searchPathNameArray('product') || App.searchPathNameArray('cart')) {
          gsap.set(window, { scrollTo: { y: 0, x: 0 } });
        }
      });
    }

    //finish setup

    let $currentPanel = Menu.$slideTrack.find('.outer-panel.active').find('.slider-panel'),
      $otherPanels = Menu.$slideTrack.find('.outer-panel:not(".active")').find('.slider-panel');

    gsap.set($currentPanel, { width: '100%', height: '100%' });

    Menu.panelSetUpOtherPanels();
  },

  headroom: function () {
    // grab an element
    const myElement = document.querySelector('#site-navigation');

    let options = {
      // vertical offset in px before element is first unpinned
      offset: 0,
      // scroll tolerance in px before state changes
      tolerance: {
        up: 5,
        down: 0,
      },
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'headroom',
        // when scrolling up
        pinned: 'headroom--pinned',
        // when scrolling down
        unpinned: 'headroom--unpinned',
        // when above offset
        top: 'headroom--top',
        // when below offset
        notTop: 'headroom--not-top',
        // when at bottom of scoll area
        bottom: 'headroom--bottom',
        // when not at bottom of scroll area
        notBottom: 'headroom--not-bottom',
        // when frozen method has been called
        frozen: 'headroom--frozen',
      },
      // element to listen to scroll events on, defaults to `window`
      // scroller : someElement,
      // callback when pinned, `this` is headroom object
      onPin: function () {},
      // callback when unpinned, `this` is headroom object
      onUnpin: function () {},
      // callback when above offset, `this` is headroom object
      onTop: function () {},
      // callback when below offset, `this` is headroom object
      onNotTop: function () {},
      // callback when at bottom of page, `this` is headroom object
      onBottom: function () {},
      // callback when moving away from bottom of page, `this` is headroom object
      onNotBottom: function () {},
    };

    // construct an instance of Headroom, passing the element
    const headroom = new Headroom(myElement, options);

    let currentPage = App.getRootURLPath();
    // initialise
    // if( Menu.disableHeadroomPages.includes( currentPage)  ){
    //     Q('#site-navigation').addClass('disablePin')
    // }else{
    //     Q('#site-navigation').removeClass('disablePin')
    //     headroom.init();
    // }
  },
  magicController: new ScrollMagic.Controller({
    // addIndicators: true
  }),

  heroScene: '',

  navBehavior: function () {
    let scrollTop = jQuery(window).scrollTop(),
      heroHeight = Menu.$menuCon.height(),
      pageHeight = jQuery('#page').height();

    let currentPage = App.getURLPath();

    Menu.magicController.destroy();
    Menu.magicController = null;
    Menu.magicController = new ScrollMagic.Controller();

    // Check if body has solid-header class - if it does, we still want to have the header behavior
    // for fixed positioning, but we'll maintain the black background
    const hasSolidHeader = jQuery('body').hasClass('solid-header');

    if (Menu.primaryPages.includes(currentPage) || currentPage === '/') {
      Menu.$siteNav.removeClass('menu-open');

      console.log('navbehavior primary');

      Menu.heroScene = new ScrollMagic.Scene({
        triggerElement: Menu.$menuCon,
        duration: heroHeight,
        triggerHook: 0.6,
        reverse: true,
      })
        .on('enter', function (event) {
          //  console.log('inside hero')

          Menu.$siteNav.addClass('inside-hero');
          Menu.$siteNav.removeClass('outside-hero');

          document.querySelector('.alert-banner').classList.add('inside-hero');
          document.querySelector('.alert-banner').classList.remove('outside-hero');
        })
        .on('leave', function (event) {
          // console.log('leaving hero')

          Menu.$siteNav.removeClass('inside-hero');
          Menu.$siteNav.addClass('outside-hero');

          document.querySelector('.alert-banner').classList.remove('inside-hero');
          document.querySelector('.alert-banner').classList.add('outside-hero');

          // if (Menu.activePanelIndx === 0) {
          //   Video.homeVideo.muted = true;
          //   Video.soundTL.seek('end').pause();
          // }
        });

      Menu.magicController.addScene([Menu.heroScene]);
    } else {
      Menu.$siteNav.removeClass('menu-open');

      console.log('navbehavior secondary');
      Menu.heroScene = new ScrollMagic.Scene({
        triggerElement: Menu.$menuCon,
        duration: pageHeight,
        triggerHook: 0.6,
        reverse: true,
      })
        .on('enter', function () {
          Menu.$siteNav.addClass('headroom--pinned');

          // Fix: Use classList instead of addClass for DOM element
          document.querySelector('.alert-banner').classList.add('outside-hero');
        })
        .on('progress', function (event) {
          if (event.scrollDirection == 'FORWARD') {
            Menu.$siteNav.addClass('inside-hero');
            // Menu.$siteNav.removeClass('outside-hero')

            document.querySelector('.alert-banner').classList.remove('inside-hero');
          } else {
            Menu.$siteNav.removeClass('inside-hero');
            Menu.$siteNav.addClass('outside-hero');

            document.querySelector('.alert-banner').classList.remove('inside-hero');
            document.querySelector('.alert-banner').classList.add('outside-hero');
          }
        });

      Menu.magicController.addScene([Menu.heroScene]);
    } //else
  },

  homeLogoLink: function () {
    jQuery('#Ck-logo').on({
      click: function () {
        document.location.href = '/';
      },
    });
  },
  reInitHeadroom() {
    this.headroom();
    this.navBehavior();
  },

  cartClickHandler: function () {
    console.log('Setting up cart click handler');
    // Check if selector is finding any elements
    const cartElements = jQuery('[data-c7-cart]');
    console.log('Found cart elements:', cartElements.length);

    cartElements.on('click', function (e) {
      console.log('Cart clicked!');
      e.preventDefault();
      console.log('c7action available:', !!window.c7action);
      console.log(
        'showSideCart available:',
        !!(window.c7action && typeof window.c7action.showSideCart === 'function')
      );

      if (window.c7action && typeof window.c7action.showSideCart === 'function') {
        console.log('Attempting to show side cart');
        window.c7action.showSideCart();
      } else {
        console.warn('c7action.showSideCart is not available');
      }
    });
  },

  cartCountObserver: function () {
    console.log('Setting up cart count observer');
    // Target elements
    const c7CartCountElement = document.querySelector('.c7-user-nav__cart__count');
    const cartCountElement = document.querySelector('.cartCount');

    console.log('c7CartCountElement found:', !!c7CartCountElement);
    console.log('cartCountElement found:', !!cartCountElement);

    if (!c7CartCountElement || !cartCountElement) {
      console.warn('Cart count elements not found');
      return;
    }

    // Initial sync of the count
    console.log('Initial cart count:', c7CartCountElement.textContent);
    cartCountElement.textContent = c7CartCountElement.textContent;

    // Set up observer
    const observer = new MutationObserver(function (mutations) {
      console.log('Cart count mutation detected', mutations.length);
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Update custom cart count with the new value
          console.log('Updating cart count to:', c7CartCountElement.textContent);
          cartCountElement.textContent = c7CartCountElement.textContent;
        }
      });
    });

    // Configure and start the observer
    observer.observe(c7CartCountElement, {
      childList: true, // observe direct children
      characterData: true, // observe text changes
      subtree: true, // observers all descendants
    });
    console.log('Cart observer setup complete');
  },

  init: function () {
    //set stage
    this.initPanel();
    this.activePanelNav();

    this.headroom();
    this.navBehavior();
    this.swipeArrows(Menu.activePanelIndx);

    //set menu color
    this.menuColor(false, false);

    //panel activation for barba
    this.panelClickData();

    //panel anchors
    this.panelAnchorLink();

    //hamburger
    this.setHamburger();
    this.menuTimeLine();
    this.hamburgerClick();

    //activate home logo
    this.homeLogoLink();

    //handle cart functionality
    this.cartClickHandler();
    this.cartCountObserver();
  },
};

export default Menu;
